const Data = [
	{
		id: 1,
		image: 'https://i.postimg.cc/L47SN8Zx/detalles-columna-marmol-gris-edificio.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas1',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '5 minutos de lectura',
		route: "/articulo1",
	},
	{
		id: 2,
		image: 'https://i.postimg.cc/3NyTYPzj/martillo-libros-sobre-escritorio-madera-antiguo.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas2',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '3 minutos de lectura',
		route: "/articulo2",
	},
	{
		id: 3,
		image: 'https://i.postimg.cc/BQK0yfT4/diseno-interior-arquitectura-antigua.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas2',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '4 minutos de lectura',
		route: "/articulo3",
	},
	{
		id: 4,
		image: 'https://i.postimg.cc/P5njnVyZ/hombre-haciendo-su-proximo-movimiento.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas1',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '3 minutos de lectura',
		route: "/articulo4",
	},
	{
		id: 5,
		image: 'https://i.postimg.cc/jd22Z44P/bodegon-balanza-justicia.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas3',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '10 minutos de lectura',
		route: "/articulo5",
	},
	{
		id: 6,
		image: 'https://i.postimg.cc/qMFRY61Y/bodegon-balanza-justicia-1.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas4',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '8 minutos de lectura',
		route: "/articulo6",
	},
	{
		id: 7,
		image: 'https://i.postimg.cc/NGpL6zmQ/hombre-negocios-trabajando-documentacion-escritorio.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas5',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '9 minutos de lectura',
		route: "/articulo7",
	},
	{
		id: 8,
		image: 'https://i.postimg.cc/xCjX3Yh4/bodegon-balanza-justicia.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas5',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '8 minutos de lectura',
		route: "/articulo8",
	},
	{
		id: 9,
		image: 'https://i.postimg.cc/fLjb3bKP/corte-martillo-libros-juicio-concepto-ley.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas2',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '8 minutos de lectura',
		route: "/articulo9",
	},
	{
		id: 10,
		image: 'https://i.postimg.cc/5yyMx9kL/martillo-libros-sobre-escritorio-madera-antiguo.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas6',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '4 minutos de lectura',
		route: "/articulo10",
	},
	{
		id: 11,
		image: 'https://i.postimg.cc/L47SN8Zx/detalles-columna-marmol-gris-edificio.jpg',
		title: '7 consejos pago de las deudas tributarias.',
		category: 'Finanzas3',
		description: '7 consejos que se pueden seguir para hacer más fácil el pago de las deudas tributarias.',
		date: 'Publicado en Sep 25 2023',
		ReadingTime: '6 minutos de lectura',
		route: "articulo11",
	},
];

export default Data;